module.exports = __webpack_public_path__ + "static/media/FeijaoCarioca.070af7ad.png";